import * as React from 'react';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import { StyledChangeDots, Child } from './styles';
const ChangeDots = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, className, }) => {
    return (React.createElement(StyledChangeDots, { className: className, size: size, color: color },
        React.createElement(Child, null),
        React.createElement(Child, { second: true })));
};
export default ChangeDots;
//# sourceMappingURL=index.js.map